<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'App',
  mounted() {
	  // Android微信中，借助WeixinJSBridge对象来阻止字体大小调整
      const handleFontSize = () => {
        // 设置网页字体为默认大小
        WeixinJSBridge.invoke('setFontSizeCallback', {fontSize: 0});
        // 重写设置网页字体大小的事件
        WeixinJSBridge.on('menu:setfont', function() {
          WeixinJSBridge.invoke('setFontSizeCallback', {fontSize: 0});
        });
      };
      try {
        // 安卓 禁止用户自定义设置字体大小
        if (typeof WeixinJSBridge == 'object' && typeof WeixinJSBridge.invoke == 'function') {
          handleFontSize();
        } else {
          if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', handleFontSize, false);
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', handleFontSize);
            document.attachEvent('onWeixinJSBridgeReady', handleFontSize);
          }
        }
      } catch (error) {}
	  
	  // Android微信中，借助WeixinJSBridge对象来阻止字体大小调整 end
    },
  data () {
    return {}
  },
  computed: {
    ...mapState({
      config: state => state.config.config
    })
  },
  created: function () {
    if (!this.config) {
      this.fetchConfig({}).then(
        res => {
          if (res.code == 10000) {
            document.title = res.result.config_list.site_name
          } else {
            Toast(res.message)
          }
        },
        error => {
          Toast(error.message)
        }
      )
    }
  },
  methods: {
    ...mapActions({
      fetchConfig: 'fetchConfig'
    })
  }
}


</script>

<style>
body {
  /* IOS 禁止用户自定义设置字体大小 */
  -webkit-text-size-adjust: 100% !important;
  text-size-adjust: 100% !important;
  -moz-text-size-adjust: 100% !important;
}
</style>
